export default {
  prospectsTimestamp(state) {
    return state.prospectsTimestamp;
  },
  prospects(state) {
    return state.prospects;
  },
  prospectsLoading(state) {
    return state.prospectsLoading;
  },
  stageCounts(state) {
    return state.stageCounts;
  },
  prospectsPage(state) {
    return {
      page: state.page,
      pageSize: state.pageSize,
      total: state.total,
    };
  },
};
